import outside from '@venegrad/vue3-click-outside'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('click-outside', outside)
  const color = nuxtApp._route.query.color

  if (import.meta.client && color) {
    const root = document.documentElement
    root.style.setProperty('--color-primary', `#${color}`)
    root.style.setProperty('--color-primary-light', `#${color}33`)
  }
})
